export default __webpack_public_path__ + "static/media/Shop.4ecbc69b.jpeg";